<template>
  <div class="d-flex flex-column justify-center align-center">

    <!--  header-->
    <TriangleHeader :title="$t('catalogues')"/>

    <!--    end header-->
    <!--    Start List-->
    <loading v-if="loading"/>
    <v-row v-else  class="mb-16 mt-16 w-80">
      <v-col class="px-1" cols="12" xl="4" lg="4" md="4"
             style="height: 340px!important;"
             v-for="(item,index) in blog.topics" :key="index">
        <CatalogueItem  :item="item"/>
      </v-col>
    </v-row>
    <!--    End List-->
  </div>
</template>

<script>
import NewsItem from "../../components/news_item/NewsItem";
import TriangleHeader from "../../components/triangle_header/TriangleHeader";
import {mapState} from "vuex";
import {GET_BLOG, GET_CATALOGUE} from "../../store/eventManagement/action_types";
import CatalogueItem from "../../components/news_item/CatalougeItem";

export default {
  name: "News",
  components: {CatalogueItem, TriangleHeader, NewsItem},
  data() {
    return {
      selectedTab: null,
    }
  },
  created() {
    this.$store.dispatch(`eventManagement/${GET_CATALOGUE}`);
  },
  computed: {
    ...mapState({
      blog: state => state.eventManagement.event,
      loading: state => state.eventManagement.loading,
    })
  }
}
</script>
